









import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import User from '@/models/User';
import { PermissionsRouter } from '@/interfaces';
import UIPermissions from '@/models/UIPermissions';
import hasPermission from '@/helpers/hasPermission';

@Component
export default class Compliance extends Vue {
  @Inject() user!: User;

  @Prop() partNumber!: string;

  public navigatorPerPermissions: PermissionsRouter[] = [
    {
      name: 'item.compliance.main',
      permissions: [UIPermissions.COMPLIANCE],
    },
    {
      name: 'item.compliance.documents',
      permissions: [UIPermissions.DECLARATION_DOCUMETNS],
    },
  ];

  async created(): Promise<void> {
    this.navigate();
  }

  public navigate(): void {
    if (this.$route.name === 'item.compliance') {
      const route = this.navigatorPerPermissions.find(
        (e) => hasPermission(this.user.permissions, e.permissions)
      );
      if (route) {
        this.$router.push({ name: route.name });
      }
    }
  }
}
